import { render, staticRenderFns } from "./AddMemberForm.vue?vue&type=template&id=36d8f1cf"
import script from "./AddMemberForm.vue?vue&type=script&lang=ts"
export * from "./AddMemberForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports